import React from "react";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Faq from "../../components/Faq";
import courses from "../../data/Courses.json";
import "./course-details-main.scss";

import { SHARE_CURRENT_COURSE, IAS_PEDAGOGY } from "../../app-constants";

const CourseDetailsMain = (props) => {
  let tab1 = "Discription",
    tab2 = "Curriculum",
    tab4 = "FAQ";
  const tabStyle = "nav nav-tabs";

  const {
    courseImg,
    courseName,
    courseAuthor,
    courseLesson,
    courseDuration,
    courseEnrolled,
    coursePrice,
    courseRegularPrice,
    courseLanguage,
  } = props;

  return (
    <div
      className="back__course__page_grid react-courses__single-page pb---16 pt---110"
      style={{ marginBottom: "70px" }}
    >
      <div className="container pb---70">
        <div className="row">
          <div className="col-lg-8">
            <div className="course-details-video mb---30">
              <iframe
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/-panOslh1zE"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <Tabs>
              <div className="course-single-tab">
                <TabList className={tabStyle}>
                  <Tab>
                    <button>{tab1}</button>
                  </Tab>
                  <Tab>
                    <button>{tab2}</button>
                  </Tab>
                  {/* <Tab>
                    <button>{tab3}</button>
                  </Tab> */}
                  <Tab>
                    <button>{tab4}</button>
                  </Tab>
                </TabList>

                <div className="tab-content" id="back-tab-content">
                  <TabPanel>
                    <div className="tab-pane">
                      <h3>About This Course</h3>
                      <div>
                        <p>
                          At <strong>IAS Jnani</strong>, we provide quality UPSC
                          coaching with a focused and personalized approach. Our{" "}
                          <strong>classroom-based course</strong> is designed to
                          equip aspirants with{" "}
                          <strong>
                            in-depth subject knowledge, analytical skills, and
                            strategic preparation techniques
                          </strong>
                          . With a{" "}
                          <strong>
                            limited batch size of {IAS_PEDAGOGY.TOTAL_INTAKE}{" "}
                            students
                          </strong>
                          , we ensure every aspirant receives the
                          <strong>best learning experience.</strong>
                        </p>

                        <h3> Why Choose IAS Jnani?</h3>
                        <div>
                          <p>
                            <strong>Quality Learning</strong> – Only{" "}
                            <strong>
                              {IAS_PEDAGOGY.TOTAL_INTAKE} aspirants per batch
                            </strong>{" "}
                            for focused interaction.
                          </p>
                          <p>
                            <strong>Regular Prelims & Mains Test Series</strong>{" "}
                            – Real exam simulation with{" "}
                            <strong>detailed evaluation</strong>.
                          </p>
                          <p>
                            <strong>Interactive Visual Learning</strong> –{" "}
                            <strong>PPTs, diagrams, and video analysis</strong>{" "}
                            for better retention.
                          </p>
                          <p>
                            <strong>
                              Expert Faculty & Personalized Mentorship
                            </strong>{" "}
                            – Guidance from <strong>experienced mentors</strong>
                            .
                          </p>
                          <p>
                            <strong>UPSC-Centric Preparation</strong> – Special
                            emphasis on{" "}
                            <strong>exam patterns & dynamic approach</strong>.
                          </p>
                        </div>

                        <h3>Course Highlights</h3>
                        <ul className="course-highlights">
                          <li>
                            <strong>
                              Limited Batch Size – {IAS_PEDAGOGY.TOTAL_INTAKE}{" "}
                              Students Only
                            </strong>
                            <br /> Personalized mentorship, one-on-one doubt
                            clearing, and individual performance tracking.
                          </li>

                          <li>
                            <strong>Prelims Preparation</strong>
                            <br /> All subjects covered with {""}
                            <strong>
                              handwritten / printed notes
                            </strong> and <strong>regular test series</strong>.
                          </li>

                          <li>
                            <strong>Mains Preparation</strong>
                            <br />
                            GS 1, GS 2, GS 3, GS 4, and Essay Writing with
                            special focus on answer writing practice.
                          </li>

                          <li>
                            <strong>
                              Guidance on Compulsory & Optional Subjects
                            </strong>
                            <br /> Strategic mentorship for compulsory and
                            optional subjects.
                          </li>

                          <li>
                            <strong>
                              Interview Guidance & Personality Development
                            </strong>
                            <br /> Special mock interviews and expert feedback
                            sessions to help aspirants perform confidently in
                            the UPSC interview.
                          </li>

                          <li>
                            <strong>
                              Classroom Sessions for a Structured Learning
                              Experience
                            </strong>
                            <br /> Interactive PPT presentations and visual
                            learning techniques for enhanced understanding.
                          </li>

                          <li>
                            <strong>
                              Comprehensive {IAS_PEDAGOGY.COURSE_DURATION}-Month
                              Course
                            </strong>
                            <br /> Covers the entire UPSC syllabus with
                            structured learning.
                          </li>
                        </ul>

                        <div>
                          <h4>📢 Admissions Open!</h4>
                          <p>
                            Join IAS Jnani and take a step closer to your dream
                            of becoming a civil servant.
                          </p>
                          <p>
                            <strong>
                              Limited seats available – Enroll now!
                            </strong>
                          </p>
                        </div>
                      </div>

                      <div className="image-banner">
                        <img src={courseImg} alt="user" />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="tab-pane">
                      <h3>Course Curriculum</h3>
                      <p>
                        At IAS Jnani, our structured curriculum is designed to
                        comprehensively cover all stages of the UPSC Civil
                        Services Examination, ensuring aspirants receive the
                        best preparation for Prelims, Mains, Current Affairs,
                        Interview, and Test Series.
                      </p>
                      <div className="single-week">
                        <ul className="week__top">
                          <li>Prelims – Mastering Objective Accuracy</li>
                          <li>Detailed Handouts</li>
                        </ul>
                        <ul
                          style={{ listStyleType: "disc", paddingLeft: "20px" }}
                        >
                          <li>
                            <b>Indian Polity</b>: Fundamental Rights,
                            Parliament, Judiciary, Federalism.
                          </li>
                          <li>
                            <b>History & Culture</b> : Ancient, Medieval, Modern
                            History & Art & Culture.
                          </li>
                          <li>
                            <b> Geography</b> : Indian & World Geography,
                            Climate, Agriculture, Mapping.
                          </li>
                          <li>
                            <b>Economy</b> : Budget, Economic Survey, RBI
                            Policies, Government Schemes.
                          </li>
                          <li>
                            <b>Environment & Ecology</b> : Climate Change,
                            Biodiversity, Wildlife Conservation.
                          </li>
                          <li>
                            <b>Science & Tech</b> : Space, AI, Biotechnology,
                            Digital Initiatives.
                          </li>{" "}
                          <li>
                            <b>Environment & Ecology</b> : Comprehension,
                            Logical Reasoning, Quantitative Aptitude.
                          </li>
                        </ul>
                      </div>

                      <div className="single-week">
                        <ul className="week__top">
                          <li>Mains – Mental Answer Writing (MAW)</li>
                          <li>Comprehensive Notes</li>
                        </ul>
                        <ul
                          style={{ listStyleType: "disc", paddingLeft: "20px" }}
                        >
                          <li>
                            <b>General Studies 1</b>: History,
                            Post-Independence, Society, World History.
                          </li>
                          <li>
                            <b>General Studies 2</b> : Governance, Constitution,
                            International Relations.
                          </li>
                          <li>
                            <b> General Studies 3</b> : Economy, Agriculture,
                            Security, Disaster Management.
                          </li>
                          <li>
                            <b>General Studies 4</b> : Ethics, Integrity & Case
                            Studies.
                          </li>
                          <li>
                            <b>Essay Writing</b> : Strategy, Theme-Based
                            Approach, Content Enrichment.
                          </li>
                        </ul>
                      </div>

                      {/* <div className="single-week">
                        <ul className="week__top">
                          <li>
                            Jnani Junction - The Ultimate Current Affairs Hub
                          </li>
                          <li>Monthly Magazine</li>
                        </ul>
                        <ul
                          style={{ listStyleType: "disc", paddingLeft: "20px" }}
                        >
                          <li>
                            <b>Government Policies & Bills</b>: Important Acts &
                            Amendments.
                          </li>
                          <li>
                            <b>International Relations</b> :India’s Bilateral &
                            Multilateral Relations.
                          </li>
                          <li>
                            <b> Economic Developments</b> : GDP, Inflation,
                            Banking, RBI Reports.
                          </li>
                          <li>
                            <b>Social Issues</b> : Education, Health, Women &
                            Child Development.
                          </li>
                          <li>
                            <b>Environment & Science</b> : Renewable Energy, AI,
                            Space Missions.
                          </li>
                        </ul>
                      </div> */}

                      <div className="single-week">
                        <ul className="week__top">
                          <li>Test Series – Practice for Perfection</li>
                          <li>Weekly Tests</li>
                        </ul>
                        <ul style={{ paddingLeft: "20px" }}>
                          <p>📌 20 Prelims Tests + 15 Mains Tests covering :</p>
                          <li>✅ Full-Length Prelims Mock Tests (GS)</li>
                          <li>✅ Topic-Wise Mains Tests (GS 1-4 + Essay)</li>
                          <li>✅ Model Answers & Personalized Evaluation</li>
                          <li>✅ Time Management & Strategy Sessions</li>
                        </ul>
                      </div>

                      <div className="single-week">
                        <ul className="week__top">
                          <li>
                            Interview – Mastering Personality & Communication
                          </li>{" "}
                          <li>Mock Interviews</li>
                        </ul>
                        <ul
                          style={{ listStyleType: "disc", paddingLeft: "20px" }}
                        >
                          <li>
                            <b>DAF-Based Personal Questions</b>: Strengths,
                            Weaknesses, Hobbies.
                          </li>
                          <li>
                            <b>Situational & Ethical Questions</b> : Integrity &
                            Decision-Making.
                          </li>
                          <li>
                            <b> Mock Interviews with Experts</b> :Realistic
                            Simulation of UPSC Board.
                          </li>
                          <li>
                            <b>Body Language & Communication</b> : Confidence,
                            Articulation, Clarity.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </TabPanel>
                  {/* <TabPanel>
                    <div className="tab-pane">
                      <h3>Reviews</h3>
                      <div className="row mt---40 mb----40">
                        <div className="col-lg-4">
                          <div className="five__number">
                            <em>4.5</em>
                            <div className="back-ratings">
                              <i className="icon_star"></i>
                              <i className="icon_star"></i>
                              <i className="icon_star"></i>
                              <i className="icon_star"></i>
                              <i className="icon_star"></i>
                            </div>
                            <h6>(4 Ratings)</h6>
                          </div>
                        </div>
                        <div className="col-lg-8">
                          <div className="back-progress-bar">
                            <div className="skillbar-style2">
                              <div className="skill_inners">
                                <span className="skillbar-title">5 stars</span>
                                <div
                                  className="skillbars green-dark-bg"
                                  data-percent="100"
                                >
                                  <p
                                    className="skillbar-bar"
                                    style={{ width: "100%" }}
                                  ></p>
                                </div>
                                <span>2</span>
                              </div>
                              <div className="skill_inners">
                                <span className="skillbar-title">4 stars</span>
                                <div
                                  className="skillbars green-dark-bg"
                                  data-percent="50"
                                >
                                  <p
                                    className="skillbar-bar"
                                    style={{ width: "50%" }}
                                  ></p>
                                </div>
                                <span>1</span>
                              </div>
                              <div className="skill_inners">
                                <span className="skillbar-title">3 stars</span>
                                <div
                                  className="skillbars green-dark-bg"
                                  data-percent="30"
                                >
                                  <p
                                    className="skillbar-bar"
                                    style={{ width: "30%" }}
                                  ></p>
                                </div>
                                <span>1</span>
                              </div>
                              <div className="skill_inners">
                                <span className="skillbar-title">2 stars</span>
                                <div
                                  className="skillbars green-dark-bg"
                                  data-percent="10"
                                >
                                  <p
                                    className="skillbar-bar"
                                    style={{ width: "10%" }}
                                  ></p>
                                </div>
                                <span>0</span>
                              </div>
                              <div className="skill_inners">
                                <span className="skillbar-title">1 stars</span>
                                <div
                                  className="skillbars green-dark-bg"
                                  data-percent="0"
                                >
                                  <p
                                    className="skillbar-bar"
                                    style={{ width: "0" }}
                                  ></p>
                                </div>
                                <span>0</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Link to="#" className="post-author">
                        <div className="avatar">
                          <img src={authorImg1} alt="user" />
                        </div>
                        <div className="info">
                          <div className="back-ratings">
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                          </div>
                          <h4 className="name">
                            Bodrum Says{" "}
                            <span className="designation">
                              July 8, 2022 at 7:38 am
                            </span>
                          </h4>
                          <p>
                            Mi eget mauris pharetra et. Bibendum arcu vitae
                            elementum curabitur vitae. Viverra mauris in aliquam
                            sem fringilla ut morbi tincidunt aliquam purus.
                          </p>
                        </div>
                      </Link>

                      <Link to="#" className="post-author">
                        <div className="avatar">
                          <img src={authorImg2} alt="user" />
                        </div>
                        <div className="info">
                          <div className="back-ratings">
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                            <i className="icon_star"></i>
                          </div>
                          <h4 className="name">
                            Hanson Deck{" "}
                            <span className="designation">
                              July 9, 2022 at 6:20 am
                            </span>
                          </h4>
                          <p>
                            Lobortis elementum nibh tellus molestie praesent
                            semper feugiat nibh sed pulvinar proin.
                          </p>
                        </div>
                      </Link>
                      <div className="blog-form pt---30">
                        <h3>Write a Review</h3>
                        <p className="pb---15">
                          Your email address will not be published. Required
                          fields are marked *
                        </p>
                        <form id="contact-form">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="back-input">
                                <input
                                  id="name"
                                  type="text"
                                  name="name"
                                  placeholder="Name"
                                />
                              </div>
                            </div>

                            <div className="col-lg-6 pdl-5">
                              <div className="back-input">
                                <input
                                  id="email"
                                  type="email"
                                  name="email"
                                  placeholder="Email"
                                />
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="back-input">
                                <input
                                  id="subject"
                                  type="text"
                                  name="subject"
                                  placeholder="Subject"
                                />
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="back-ratings">
                                {" "}
                                <b>Ratings:</b>
                                <i className="icon_star"></i>
                                <i className="icon_star"></i>
                                <i className="icon_star"></i>
                                <i className="icon_star"></i>
                                <i className="icon_star"></i>
                              </div>
                              <div className="back-textarea">
                                <textarea
                                  id="message"
                                  name="message"
                                  placeholder="Message"
                                ></textarea>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <button type="submit" className="back-btn">
                                Submit Review{" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="feather feather-arrow-right"
                                >
                                  <line x1="5" y1="12" x2="19" y2="12"></line>
                                  <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </TabPanel> */}
                  <TabPanel>
                    <div className="tab-pane">
                      <h3>FAQ</h3>
                      <Faq />
                    </div>
                  </TabPanel>
                </div>
              </div>
            </Tabs>
            {/* <div className="react-course-filter related__course">
              <h3>Related Courses</h3>
              <div className="row react-grid">
                {courses
                  .map((data, index) => {
                    return (
                      <div className="single-studies col-lg-6 grid-item">
                        <div className="inner-course">
                          <div className="case-img">
                            <Link to={`/course/${data.id}`} className="cate-w">
                              {data.name}
                            </Link>
                            <img
                              src={require(`../../assets/images/course/${data.image}`)}
                              alt={data.title}
                            />
                          </div>
                          <div className="case-content">
                            <ul className="meta-course">
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="feather feather-star"
                                >
                                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                </svg>{" "}
                                {data.review} review{" "}
                              </li>
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="feather feather-user"
                                >
                                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                  <circle cx="12" cy="7" r="4"></circle>
                                </svg>{" "}
                                {data.enrolled} Students Enrolled{" "}
                              </li>
                            </ul>
                            <h4 className="case-title">
                              {" "}
                              <Link to={`/course/${data.id}`}>
                                {data.title}
                              </Link>
                            </h4>
                            <div className="react__user">
                              <img
                                src={require(`../../assets/images/course/${data.authorImg}`)}
                                alt={data.author}
                              />{" "}
                              {data.author}
                            </div>
                            <ul className="react-ratings">
                              <li className="react-book">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="feather feather-file-text"
                                >
                                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                  <polyline points="14 2 14 8 20 8"></polyline>
                                  <line x1="16" y1="13" x2="8" y2="13"></line>
                                  <line x1="16" y1="17" x2="8" y2="17"></line>
                                  <polyline points="10 9 9 9 8 9"></polyline>
                                </svg>{" "}
                                {data.lesson} Lectures
                              </li>
                              <li className="price">{data.price}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    );
                  })
                  .slice(4, 6)}
              </div>
            </div> */}
          </div>
          <div className="col-lg-4 md-mt-60">
            <div className="react-sidebar react-back-course2 ml----30">
              <div className="widget get-back-course">
                <ul className="price">
                  <li>{coursePrice}</li>
                  {/* <li>{courseRegularPrice} USD</li> */}
                  {/* <li>25% OFF</li> */}
                </ul>
                <ul className="price__course">
                  <li>
                    {" "}
                    <i className="icon_profile"></i> Instructor{" "}
                    <b>{courseAuthor}</b>
                  </li>
                  <li>
                    <i className="icon_tag_alt"></i> Subject <b>{courseName}</b>
                  </li>
                  <li>
                    {" "}
                    <i className="icon_group"></i> Enrolled{" "}
                    <b>{courseEnrolled} students</b>
                  </li>
                  <li>
                    <i className="icon_clock_alt"></i> Duration{" "}
                    <b>{courseDuration}</b>
                  </li>
                  <li>
                    <i className="icon_book_alt"></i> Lectures{" "}
                    <b>{courseLesson} lectures</b>
                  </li>
                  <li>
                    <i className="icon_map_alt"></i> Language{" "}
                    <b> {courseLanguage}</b>
                  </li>
                </ul>
                <Link
                  to={`https://wa.me/${
                    IAS_PEDAGOGY.WHATSAPP_CHAT
                  }?text=${encodeURIComponent(
                    IAS_PEDAGOGY.WHATSAPP_CHAT_MESSAGE
                  )}`}
                  className="start-btn"
                  target="_blank"
                >
                  Enroll Now{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="feather feather-arrow-right"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </Link>
                <div
                  className="share-course"
                  onClick={() => {
                    const shareUrl = SHARE_CURRENT_COURSE;
                    window.open(shareUrl, "_blank");
                  }}
                  style={{ cursor: "pointer" }} // Makes it clear that it's clickable
                >
                  Share this course{" "}
                  <em>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="feather feather-share-2"
                    >
                      <circle cx="18" cy="5" r="3"></circle>
                      <circle cx="6" cy="12" r="3"></circle>
                      <circle cx="18" cy="19" r="3"></circle>
                      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                    </svg>
                  </em>
                  {/* <span>
                    <a
                      href={`https://wa.me/?text=${encodeURIComponent(
                        "Check out this amazing UPSC course: " +
                          IAS_PEDAGOGY.SHARE_COURSE
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i aria-hidden="true" className="social_whatsapp"></i>
                    </a>

                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        IAS_PEDAGOGY.SHARE_COURSE
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i aria-hidden="true" className="social_facebook"></i>
                    </a>

                    <a
                      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                        IAS_PEDAGOGY.SHARE_COURSE
                      )}&text=${encodeURIComponent(
                        "Check out this amazing UPSC course!"
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i aria-hidden="true" className="social_twitter"></i>
                    </a>

                    <a
                      href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                        window.location.href
                      )}&title=${encodeURIComponent(
                        "UPSC Course - IAS Jnani"
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i aria-hidden="true" className="social_linkedin"></i>
                    </a>
                  </span> */}
                </div>
              </div>
              <div className="widget react-categories-course">
                <h3 className="widget-title">Course categories</h3>
                <ul className="recent-category">
                  <li>
                    {" "}
                    <Link to="/course">Civil Service Examination (3)</Link>
                  </li>
                  {/* <li>
                    {" "}
                    <Link to="/course">Exercise (4)</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/course">Photography (8)</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/course">Environmental Sciences (3)</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/course">Software Training (5)</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/course">Software Development (2)</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/course">Music (10)</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/course">Material Design (2)</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/course">Technology (7)</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetailsMain;
